import {
  GoogleProviderIcon,
  MicrosoftProviderIcon,
} from "@/components/shared/auth/auth-provider-icons";
import { Button } from "@/components/ui/button";
import { SMTP_PROVIDERS, getSniperLink } from "@/lib/auth/sniper-links";
import type { ReactNode } from "react";

function OutlookIcon() {
  return <MicrosoftProviderIcon />;
}

export function OpenWithEmailButtons({
  smtpProvider,
  isEnabled,
  ctaLabel,
}: {
  smtpProvider: string | null;
  isEnabled: boolean;
  ctaLabel: string;
}) {
  const provider = SMTP_PROVIDERS[smtpProvider as keyof typeof SMTP_PROVIDERS];
  if (provider == null) return null;

  const entries: Array<{
    key: string;
    label: string;
    href: string;
    icon?: ReactNode;
  }> = [];

  if (provider === SMTP_PROVIDERS.unknown) {
    entries.push({
      key: "outlook",
      label: "Outlook",
      href: getSniperLink(SMTP_PROVIDERS.microsoft) as string,
      icon: <OutlookIcon />,
    });
    entries.push({
      key: "gmail",
      label: "Gmail",
      href: getSniperLink(SMTP_PROVIDERS.google) as string,
      icon: <GoogleProviderIcon />,
    });
  }

  if (provider === SMTP_PROVIDERS.google) {
    entries.push({
      key: "gmail",
      label: "Gmail",
      href: getSniperLink(SMTP_PROVIDERS.google) as string,
      icon: <GoogleProviderIcon />,
    });
  }

  if (provider === SMTP_PROVIDERS.microsoft) {
    entries.push({
      key: "outlook",
      label: "Outlook",
      href: getSniperLink(SMTP_PROVIDERS.microsoft) as string,
      icon: <OutlookIcon />,
    });
  }

  if (provider === SMTP_PROVIDERS.apple) {
    entries.push({
      key: "icloud",
      label: "iCloud",
      href: getSniperLink(SMTP_PROVIDERS.apple) as string,
    });
  }

  if (provider === SMTP_PROVIDERS.yahoo) {
    entries.push({
      key: "yahoo",
      label: "Yahoo",
      href: getSniperLink(SMTP_PROVIDERS.yahoo) as string,
    });
  }

  if (provider === SMTP_PROVIDERS.proton) {
    entries.push({
      key: "proton",
      label: "Proton",
      href: getSniperLink(SMTP_PROVIDERS.proton) as string,
    });
  }

  if (entries.length === 0) return null;

  return (
    <div className="grid gap-3 pt-2">
      <p className="text-sm text-muted-foreground text-center">{ctaLabel}</p>

      <div className="grid gap-2">
        {entries.map((entry) => {
          const hasIcon = "icon" in entry;
          const disabled = !isEnabled || !entry.href;

          if (disabled) {
            return (
              <Button
                key={entry.key}
                variant="outline"
                className={hasIcon ? "w-full gap-2" : "w-full"}
                disabled
              >
                {hasIcon ? (
                  <>
                    {entry.icon}
                    {entry.label}
                  </>
                ) : (
                  entry.label
                )}
              </Button>
            );
          }

          return (
            <Button
              key={entry.key}
              asChild
              variant="outline"
              className={hasIcon ? "w-full gap-2" : "w-full"}
            >
              <a href={entry.href} target="_blank" rel="noreferrer">
                {hasIcon ? (
                  <>
                    {entry.icon}
                    {entry.label}
                  </>
                ) : (
                  entry.label
                )}
              </a>
            </Button>
          );
        })}
      </div>
    </div>
  );
}
